module.exports = __webpack_public_path__ + "img/reference06.c0628dcb.jpg";